import {
  useQueryWithSimpleErrorHandling as useQueryWithErrorHandling,
  useClientQueryWithSimpleErrorHandling as useClientQueryWithErrorHandling,
  useSimpleError as useError
} from "@ts-private/apollo-tools";
import { useToast } from "@totalsoft/rocket-ui";

export const useSimpleError = () => {
  const addToast = useToast();
  const showError = useError((message, type, correlationId) =>
    addToast(message, type, { autoClose: true }, correlationId)
  );
  return showError;
};

export function useQueryWithSimpleErrorHandling(query, options) {
  return useQueryWithErrorHandling(query, options, useSimpleError)
}

export function useClientQueryWithSimpleErrorHandling(query, options) {
  return useClientQueryWithErrorHandling(query, options, useSimpleError)
}